import { Injectable, OnDestroy, QueryList, ViewChildren, Optional } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { Subject } from "rxjs";
import { FeedbackService } from "../../services/feedback.service";
import { InfoDialogComponent } from './../../../shared/components/info-dialog/info-dialog.component';
import { MatMenuTrigger } from "@angular/material/menu";
import { LoaderService, LoaderInterceptorService } from "../../services/loader.service";

@Injectable()
export class BaseComponent implements OnDestroy {
  protected destroy$ = new Subject<void>();
  
  // Expose loading state from loader service
  protected get isLoading$() {
    return this.loaderService?.loaderState;
  }
  
  protected get activeRequests$() {
    return this.loaderInterceptor?.requests$;
  }

  constructor(
    protected feedbackService: FeedbackService, 
    protected dialog: MatDialog,
    @Optional() protected loaderService?: LoaderService,
    @Optional() protected loaderInterceptor?: LoaderInterceptorService
  ) { }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showToastMessage(message: string) {
    this.feedbackService.showToast(message, 'OK', 3000);
  }

  async showConfirmationDialog(
    title: string = 'CONFIRM',
    message: string = 'Are you sure you want to perform this action?',
    data?: any[],
    cancelText: string = 'Cancel',
    confirmText: string = 'Confirm',
    needsAiDisclaimer: boolean = false,
    cooldownSeconds?: number
  ): Promise<boolean> {
    return this.feedbackService.showConfirmation(title, message, data, cancelText, confirmText, needsAiDisclaimer, cooldownSeconds);
  }

  protected showInfoDialog(title: string, content: string[]) {
    this.dialog.open(InfoDialogComponent, {
      width: '300px',
      data: {
        title: title,
        content: content
      }
    });
  }

  closeAllMenus(menuTriggers: QueryList<MatMenuTrigger>): void {
    menuTriggers.forEach(trigger => trigger.closeMenu());
  }

}